export const SET_USER = 'SET_USER'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER_LOADING = 'SET_USER_LOADING'
export const SET_GRADES_LECTURES = 'SET_GRADES_LECTURES'
export const CLEAR_ALL = 'CLEAR_ALL'
export const REALLOCATION_DATE_LIMIT = 'REALLOCATION_DATE_LIMIT'
export const SET_YEAR_SELECTED_CONTENT = 'SET_YEAR_SELECTED_CONTENT'
